import * as DOMPurify from 'dompurify'

const sanitize = (
  dirty: string | Node,
  allowedTags: string[] = [],
  allowedAttributes: string[] = [],
) => ({
  __html: DOMPurify.sanitize(dirty, {
    ALLOWED_TAGS: allowedTags,
    ALLOWED_ATTR: allowedAttributes,
  }),
})

export default sanitize
